export const ManagersIdsMap = {
  IlyaYakimchuk: {
    name: 'Илья',
    secName: 'Якимчук',
    position: 'Заместитель руководителя отдела развития регионов',
    phone: '+7 903 763 9777',
    email: 'i.yakimchuk@energo.app',
    telegram: 'wholikeshadow',
    watsapp: '79037639777'
  },
  StanislavKapkaev: {
    name: 'Станислав',
    secName: 'Капкаев',
    position: 'Руководитель отдела франчайзинг',
    phone: '+7 926 999 3111',
    email: 's.kapkaev@energo.app',
    telegram: 'superkapkaev',
    watsapp: '79269993111'
  },
  VladimirKozlov: {
    name: 'Владимир',
    secName: 'Козлов',
    position: 'Директор по развитию',
    phone: '+7 925 006 01 44',
    email: 'partners@energo.app',
    telegram: 'kozlov_vs',
    watsapp: '79250060144'
  },
  GeorgiyKartushin: {
    name: 'Георгий',
    secName: 'Картушин',
    position: 'Операционный директор',
    phone: '+7 985 121 47 71',
    email: 'g.kartushin@energo.app',
    telegram: 'Georgiy_Kartushin',
    watsapp: '79851214771'
  },
  AntonShalimov: {
    name: 'Антон',
    secName: 'Шалимов',
    position: 'Руководитель event-проектов',
    phone: '+7 915 452 8828',
    email: 'a.shalimov@energo.app',
    telegram: 'Anton_Shaman',
    watsapp: '79154528828'
  },
  AlekseyHarchenko: {
    name: 'Алексей',
    secName: 'Харченко',
    position: 'Руководитель коммерческого отдела',
    phone: '+7 926 841 0441',
    email: 'alexey.harchenko@energo.app',
    telegram: 'HarchenkoAlexey',
    watsapp: '79268410441'
  },
  SergeyMayorov: {
    name: 'Сергей',
    secName: 'Майоров',
    position: 'Руководитель развития регионов',
    phone: '+7 977 588 7254',
    email: 's.mayorov@energo.app',
    telegram: 'Mayorov_Sergey_A',
    watsapp: '79775887254'
  },
  DamirValiev: {
    name: 'Дамир',
    secName: 'Валиев',
    position: 'Менеджер по развитию регионов',
    phone: '+7 927 678 5557',
    email: 'd.valiev@energo.app',
    telegram: 'DamirValiev',
    watsapp: '79276785557'
  },
  DmitryKazakov: {
    name: 'Дмитрий',
    secName: 'Казаков',
    position: 'Региональный управляющий',
    phone: '+7 929 203 2035',
    email: 'd.kazakov@energo.app',
    telegram: 'KazakDS',
    watsapp: '79292032035'
  },
  AlekseyKlimov: {
    name: 'Алексей',
    secName: 'Климов',
    position: 'Старший техник Южного округа',
    phone: '+7 962 603 0264',
    email: 'a.klimov@energo.app',
    telegram: 'Siburoid',
    watsapp: '79626030264'
  },
  DmitryGolikov: {
    name: 'Дмитрий',
    secName: 'Голиков',
    position: 'Менеджер по г. Сочи',
    phone: '+7 936 154 2100',
    email: 'd.golikov@energo.app',
    telegram: 'Dmitrii9356',
    watsapp: '79361542100'
  },
  SergeySokorokopud: {
    name: 'Сергей',
    secName: 'Сорокопуд',
    position: 'Техник',
    phone: '+7 925 999 3022',
    email: 's.sorokopud@energo.app',
    telegram: 'Sergeygtt',
    watsapp: '79259993022'
  },
  KirillShalimov: {
    name: 'Кирилл',
    secName: 'Шалимов',
    position: 'Старший менеджер по развитию сети',
    phone: '+7 916 646 2343',
    email: 'k.shalimov@energo.app',
    telegram: 'shalimov_k',
    watsapp: '79166462343'
  },
};